module.exports = __webpack_public_path__ + "static/5_section_bg-753dcd5a00f26073844e3cca4f628f55.svg";